var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "interment-edit-wrapper" }, [
    _c(
      "form",
      {
        attrs: {
          autocomplete: "off",
          method: "post",
          "data-vv-scope": _vm.vScope,
        },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return (() => {
              return false
            }).apply(null, arguments)
          },
          submit: function ($event) {
            $event.preventDefault()
            return (() => {
              return false
            }).apply(null, arguments)
          },
        },
      },
      [
        _vm.isNew
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("IntermentLocation", {
                    attrs: {
                      additional: _vm.additional,
                      panelCfg: _vm.panelCfg,
                      vScope: _vm.vScope,
                      readonlyForm: _vm.readonlyForm,
                      baseTranslateID: _vm.baseTranslateID,
                      cemeteries: _vm.cemeteries,
                    },
                    model: {
                      value: _vm.form,
                      callback: function ($$v) {
                        _vm.form = $$v
                      },
                      expression: "form",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-sm-12" }, [
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.itemsForm, function (item) {
                return _c(
                  "div",
                  {
                    key: `interment-${item.key}-wrapper`,
                    class: `col-12 col-md-12 col-lg-6 accordion interment-${item.key}-wrapper`,
                  },
                  [
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card-header",
                          attrs: { id: `heading-interment-${item.key}` },
                        },
                        [
                          _c(
                            "button",
                            {
                              class: `btn btn-link btn-block interment-header`,
                              attrs: {
                                type: "button",
                                "aria-expanded": `${item?.expanded ?? false}`,
                                "data-toggle": "collapse",
                                "data-target": `#collapse-interment-${item.key}`,
                                "aria-controls": `#collapse-interment-${item.key}`,
                              },
                            },
                            [
                              _c(
                                "h3",
                                { staticClass: "interment-panel-title" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          `${_vm.modelTranslateID}.${item.key}.title`
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { class: `interment-panel-desc` }, [
                                _c("i", {
                                  staticClass: "fas fa-chevron-right",
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [
                            "collapse",
                            { show: item?.expanded ?? false },
                          ],
                          attrs: {
                            id: `collapse-interment-${item.key}`,
                            "aria-labelledby": `heading-interment-${item.key}`,
                          },
                        },
                        [
                          _c("div", { staticClass: "card-body" }, [
                            _c(
                              "div",
                              { class: `interment-${item.key}-content` },
                              [
                                _c(item.component, {
                                  tag: "component",
                                  attrs: {
                                    additional: _vm.additional,
                                    panelCfg: _vm.panelCfg,
                                    vScope: _vm.vScope,
                                    readonlyForm: _vm.readonlyForm,
                                    baseTranslateID: _vm.baseTranslateID,
                                    interment_types: _vm.interment_types,
                                    container_types: _vm.container_types,
                                    genders: _vm.genders,
                                    religions: _vm.religions,
                                    causes_death: _vm.causes_death,
                                  },
                                  model: {
                                    value: item.model,
                                    callback: function ($$v) {
                                      _vm.$set(item, "model", $$v)
                                    },
                                    expression: "item.model",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }